module.exports = __webpack_public_path__ + "static/media/kimkevin19.928f81f3.png";